enum PlayableStatus {
  tooEarly,
  playable,
  tooLate
}
export default PlayableStatus;
